var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTonga(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.4531C24.8366 32.4531 32 25.2897 32 16.4531C32 7.61657 24.8366 0.453125 16 0.453125C7.16344 0.453125 0 7.61657 0 16.4531C0 25.2897 7.16344 32.4531 16 32.4531Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4349 8.8011V6.71416H8.34792V8.8011H6.26099V10.8881H8.34792V12.975H10.4349V10.8881H12.5219V8.8011H10.4349Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.453125V16.4531C7.1635 16.4532 3.65156 16.4531 0 16.4532C0 25.2896 7.1635 32.4531 16 32.4531C24.8365 32.4531 32 25.2896 32 16.4531C32 7.61662 24.8365 0.453125 16 0.453125Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.453125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTonga);
export default __webpack_public_path__ + "static/media/tonga.f139ef26.svg";
export { ForwardRef as ReactComponent };